import { Component, OnInit, computed, inject, input } from '@angular/core';

import { CasinoLobbyService, CasinoManager, ConfigProviderService } from '@casinocore/platform/core';

import { CasinoCoreLazyPlaceholderComponent } from '../../casino-core-lazy-placeholder/casino-core-lazy-placeholder.component';

@Component({
    selector: 'cc-nav-news-feed',
    template: `@if (shouldShowNewsFeed()) {
        <div data-testid="nav-news-feed-container" [style.position]="newsFeedPosition == 'above-subnav' ? 'relative' : 'unset'">
            <cc-casino-core-lazy-placeholder [inputData]="{ lobbyType: lobbyType }" [componentName]="'NewsFeedComponent'" />
        </div>
    }`,
    imports: [CasinoCoreLazyPlaceholderComponent],
})
export class NavNewsFeedComponent implements OnInit {
    extendMenuDslEvalCompleted = input<boolean>(false);
    lobbyType = input.required<string>();
    categoryRoute = input.required<string>();
    isLobbyLoaded = input.required<boolean>();
    private defaultCategoryType: { categoryid: string };

    isNewsFeedEnabledOnHome: boolean;
    isNewsFeedEnabled: boolean;
    newsFeedPosition: string;
    isDefaultCategory: boolean;

    private casinoLobbyService = inject(CasinoLobbyService);
    private configProviderService = inject(ConfigProviderService);
    private casinoManager = inject(CasinoManager);

    readonly shouldShowNewsFeed = computed(
        () =>
            this.isLobbyLoaded() &&
            this.extendMenuDslEvalCompleted() &&
            this.isNewsFeedEnabled &&
            this.isDefaultCategory &&
            this.isNewsFeedEnabledOnHome,
    );

    ngOnInit() {
        const newsFeedConfig = this.configProviderService.provideNewsFeedCasinoConfig();
        if (newsFeedConfig && this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType(), newsFeedConfig.newsFeedPosition)) {
            this.isNewsFeedEnabled = newsFeedConfig.isEnabled;
            this.isNewsFeedEnabledOnHome = newsFeedConfig.isEnabledOnHomeCategory;
            this.newsFeedPosition = newsFeedConfig.newsFeedPosition;
        }
        this.defaultCategoryType = this.casinoLobbyService.getDefaultOrFirstCategoryInfo(this.lobbyType())?.categoryInfo;
        this.isDefaultCategory = this.defaultCategoryType && this.defaultCategoryType.categoryid === this.categoryRoute();
    }
}
